module.exports = __webpack_public_path__ + "img/CESE-Zertifikat_de.125a0e04.webp";